import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import SEO from "@/components/SEO";
import Services from "@/components/Services";
import DocuWareSection from "@/components/DocuWareSection";
import CoverageSection from "@/components/CoverageSection";
import CoverageBanner from "@/components/CoverageBanner";
import VideoSection from "@/components/VideoSection";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import ChatBot from "@/components/ChatBotLoader";

const Index = () => (
  <div className="min-h-screen">
    <SEO
      title="IntegraDoc GT — DocuWare en LatAm y EE. UU."
      description="Distribuidor autorizado de DocuWare para Latinoamérica y Estados Unidos. Digitalización y gestión documental con cumplimiento normativo y fiscal en cada país."
      canonical="/"
      jsonLd={{
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: "IntegraDoc GT",
        url: "https://integradocgt.com/",
        inLanguage: "es-GT",
        description:
          "Distribuidor autorizado de DocuWare para Latinoamérica y Estados Unidos, con cumplimiento normativo y fiscal adaptado a cada país.",
        about: {
          "@type": "Service",
          name: "Gestión documental con DocuWare",
          areaServed: [
            { "@type": "Country", name: "Guatemala" },
            { "@type": "Country", name: "México" },
            { "@type": "Country", name: "El Salvador" },
            { "@type": "Country", name: "Honduras" },
            { "@type": "Country", name: "Nicaragua" },
            { "@type": "Country", name: "Costa Rica" },
            { "@type": "Country", name: "Panamá" },
            { "@type": "Country", name: "Belice" },
            { "@type": "Country", name: "Estados Unidos" },
          ],
        },
      }}
    />
    <Navbar />
    <Hero />
    <CoverageBanner />
    <Services />
    <DocuWareSection />
    <CoverageSection />
    <VideoSection />
    <FAQ />
    <Contact />
    <Footer />
    <ChatBot />
  </div>
);

export default Index;
